import {css, FlattenSimpleInterpolation} from 'styled-components';

export const darkTheme = (styles: FlattenSimpleInterpolation) => css`
  [data-theme='dark'] & {
    ${styles}
  }
`;

export const lightTheme = (styles: FlattenSimpleInterpolation) => css`
  [data-theme='light'] & {
    ${styles}
  }
`;
